import React from 'react'
import SignedInNavbarImproved from '../../SignedInNavbarImproved'
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import Container from '../my_container/Container';
import rulesImageOne from '../../../assets/rulesImageOne.png';
import rulesImageTwo from '../../../assets/rulesImageTwo.png';
import rulesImageThree from '../../../assets/rulesImageThree.png';

const ReturnsPolicyPage = () => {
    const navigate = useNavigate();


    const returnsRules = [{Image: rulesImageOne, description: "You have 3-7 days after delivery to return items."}, 
        {Image: rulesImageTwo, description: "We only give Item replacements- no store credit or money back."},
        {Image: rulesImageThree, description: "We'll handle your request within 7 days"}]
  return (
    <>
        <SignedInNavbarImproved />
        <div className='min-h-screen bg-white text-gray-800'>
            <Container className="pt-8 pb-20">
                <div className='mb-8 flex items-center justify-between'>
                    <div className="flex items-center space-x-2 sm:space-x-4">
                        <div
                            onClick={() => navigate(-1)}
                            className="rounded-full p-1 hover:bg-gray-200"
                        >
                            <BiArrowBack className="h-6 w-6 cursor-pointer text-gray-600" />
                        </div>
                        <div className="text-lg font-bold text-gray-700 sm:text-2xl">
                            Returns Policy Page
                        </div>
                    </div>
                    <button onClick={() => navigate("/returns-policy/returns-history")} className="flex items-center space-x-2">
                        <span>
                            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.3335 4C14.1509 4 11.0987 5.26428 8.84821 7.51472C6.59778 9.76515 5.3335 12.8174 5.3335 16H1.3335L6.52016 21.1867L6.6135 21.3733L12.0002 16H8.00016C8.00016 10.84 12.1735 6.66667 17.3335 6.66667C22.4935 6.66667 26.6668 10.84 26.6668 16C26.6668 21.16 22.4935 25.3333 17.3335 25.3333C14.7602 25.3333 12.4268 24.28 10.7468 22.5867L8.8535 24.48C9.96472 25.5973 11.2861 26.4837 12.7416 27.0878C14.197 27.6919 15.7577 28.002 17.3335 28C20.5161 28 23.5683 26.7357 25.8188 24.4853C28.0692 22.2348 29.3335 19.1826 29.3335 16C29.3335 12.8174 28.0692 9.76515 25.8188 7.51472C23.5683 5.26428 20.5161 4 17.3335 4ZM16.0002 10.6667V17.3333L21.7068 20.72L22.6668 19.1067L18.0002 16.3333V10.6667H16.0002Z" fill="#558223"/>
                            </svg>
                        </span>
                        <span className='font-medium text-[#558223]'>Returns History</span>
                    </button>
                </div>
                <ul>
                    <li className='mb-4'>Any Item can be returned at a time up to 3-7 Days after delivery</li>
                    <li className='mb-4'>We do not accept returns for refunds. If there is an issue with an item, we can only offer a replacement.</li>
                    <li className='mb-4'>Grocedy does not offer refunds, however, we are more than happy to replace any item, you are not satisfied with.</li>
                </ul>
                <div>
                    <h2 className='mb-6 mt-12 text-2xl font-bold text-gravel-600'>Return Rules</h2>
                    <div className='grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3'>
                        {returnsRules.map((rule, index) => (
                            <div key={index} className='flex flex-col space-y-4 bg-[#F2F2F3] p-6 border border-gray-200 rounded'>
                                <div className='h-24 w-fit '>
                                    <img src={rule.Image} alt={`Rule ${index + 1}`} className='h-full w-full object-contain' /> 
                                </div>
                                <p className='text-gray-600 font-medium'>{rule.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    </>
  )
}

export default ReturnsPolicyPage